import bilAPI from "./api";

// `page_size` (backend caps at 1000) lets the class pickers fetch every group
// in one request — without it the dropdowns were capped at the first 20.
export const getGroups = ({ params: { organization, page, page_size } = {}, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/org/groups/`, { params: { organization, page, page_size }, signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const createGroup = ({ body, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/org/groups/`, body, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const updateGroup = ({ uuid, body, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/org/groups/${uuid}/`, body, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const deleteGroup = ({ uuid, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/org/groups/${uuid}/`, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};
